/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />

namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialReceiptItemsDialog extends _Ext.ItemEditorDialog<MaterialReceiptItemsRow> {
        protected getFormKey() { return MaterialReceiptItemsForm.formKey; }
        //protected getIdProperty() { return MaterialReceiptItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MaterialReceiptItemsRow.localTextPrefix; }
        // protected getNameProperty() { return MaterialReceiptItemsRow.nameProperty; }
        //protected getService() { return MaterialReceiptItemsService.baseUrl; }
        protected getDeletePermission() { return MaterialReceiptItemsRow.deletePermission; }
        protected getInsertPermission() { return MaterialReceiptItemsRow.insertPermission; }
        protected getUpdatePermission() { return MaterialReceiptItemsRow.updatePermission; }

        protected form = new MaterialReceiptItemsForm(this.idPrefix); 
         
        constructor() {
            super();

            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.Pieces);


            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                if (OMS.ProductSelectGrid.ItemType == 3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 3) {
                        this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });
            // **** On Weight Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (OMS.ProductSelectGrid.ItemType == 3) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    //Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            this.form.UnitRate.changeSelect2(e => {
                if (parseInt(this.form.CalcOnId.value) == 3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
            }); 

            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

           
            // **** On Wastage % Change Event **** 
            //this.form.WstPer.changeSelect2(e => {
            //    this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            //});

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });
             

            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 
            this.form.ProductCode.changeSelect2(e => {
                try {
                    let id;
                    OMS.ProductMasterService.CustomList({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                        response => {
                            id = response.Entities[0];
                        }, { async: false });
                    if (id.ProductId != null || id.ProductId > 0) {
                        Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                        this.form.ProductCode.value = "";
                        this.form.ProductCode.element.focus();
                        return;

                    }
                }
                catch (undefined) {

                }
            });

        }


        onDialogOpen() {
            super.onDialogOpen();
            this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.QualityId) : q.showAndSetRequiredField(this.form.QualityId);
            this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.SieveId) :q.showAndSetRequiredField(this.form.SieveId);
            this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneColorId) :q.showAndSetRequiredField(this.form.StoneColorId);
            this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneSizeId) :q.showAndSetRequiredField(this.form.StoneSizeId);
            q.showAndSetRequiredField(this.form.UnitRate);
            q.showAndDisableField(this.form.ProductCode);
            q.showAndDisableField(this.form.ProductName);
            q.hideField(this.form.KaratId);
            q.hideField(this.form.MetalColorId); 
            q.hideField(this.form.Purity);
            q.hideField(this.form.PureWeight)
            q.hideField(this.form.Purity);
            this.form.CalcOnId.value = "5";
            this.form.CalcUnitId.value = "8"
            q.showAndDisableField(this.form.LotNo);

            if (this.form.ItemTypeId.value == 0)
                this.form.ItemTypeId.value = 105;

            switch (parseInt(this.form.CategoryId.value)) {
                case 1:
                case 3:
                case 4:
                    q.hideField(this.form.StoneCutId);
                    q.hideField(this.form.StonePolishId);
                    q.hideField(this.form.StoneSymmetryId);
                    q.hideField(this.form.StoneFluorescenceId);
                    q.hideField(this.form.StoneCuletId);
                    q.hideField(this.form.StoneGirdleId);
                    q.hideField(this.form.StoneTable);
                    q.hideField(this.form.StoneDepth);
                    q.hideField(this.form.CertificateNo);
                    //q.hideEditorCategory(this.form.StoneCuletId);
                    break;
                case 2:
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneCutId) :q.showAndSetRequiredField(this.form.StoneCutId);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StonePolishId) :q.showAndSetRequiredField(this.form.StonePolishId);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneSymmetryId) : q.showAndSetRequiredField(this.form.StoneSymmetryId);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneFluorescenceId) : q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneCuletId) : q.showAndSetRequiredField(this.form.StoneCuletId);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneGirdleId) : q.showAndSetRequiredField(this.form.StoneGirdleId);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneTable) : q.showAndSetRequiredField(this.form.StoneTable);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.StoneDepth) :  q.showAndSetRequiredField(this.form.StoneDepth);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.CertificateNo) :  q.showAndSetRequiredField(this.form.CertificateNo);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.Pieces) : q.showAndSetRequiredField(this.form.Pieces);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.Weight) : q.showAndSetRequiredField(this.form.Weight);
                    this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.Lab) : q.showAndSetRequiredField(this.form.Lab);

                    break;
            }
            this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.ProductTypeId) : q.showAndSetRequiredField(this.form.ProductTypeId);
            this.entity.IsConfigurable != true ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
            this.entity.IsConfigurable != true? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
            this.entity.IsConfigurable != true? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
        }

        afterLoadEntity() {
            super.afterLoadEntity();
        }
         
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            //btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            return btns;
        }
         
        protected validateBeforeSave() {
            var IsValid = true;
            this.form.AttributeId.value = "0";
            return IsValid;
        }
    }
}